import { type TextareaHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils/cn';

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  label?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, label, id, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={id}
            className="mb-1.5 block text-sm font-medium text-text-primary dark:text-gray-200"
          >
            {label}
          </label>
        )}
        <textarea
          className={cn(
            'form-textarea block w-full rounded-lg border py-2.5 text-sm transition-all',
            'focus:border-primary focus:ring-1 focus:ring-primary focus:outline-none',
            'placeholder-gray-400',
            'bg-white dark:bg-surface-dark-elevated',
            'border-gray-200 dark:border-gray-700',
            'text-text-primary dark:text-white',
            'px-3 min-h-[80px] resize-y',
            error && 'border-red-300 focus:border-red-500 focus:ring-red-500 dark:border-red-700',
            className,
          )}
          ref={ref}
          id={id}
          {...props}
        />
        {error && (
          <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>
        )}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
